import React, { FC, useRef } from 'react';
// import { TextWithStyle } from 'components/TextWithStyle';
import './Vision.css';
import { motion, useInView } from "framer-motion";

export const Vision: FC = () => {
  const signatureSrc = `${process.env.PUBLIC_URL}/assets/signature.png`;
  const annaSrc = `${process.env.PUBLIC_URL}/assets/teamPhotos/Anna.png`;
  const vivSrc = `${process.env.PUBLIC_URL}/assets/teamPhotos/Viv.png`;
  const toastie = `${process.env.PUBLIC_URL}/assets/toastie-logo.png`;

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <div className="vision">
      <div className="home-content-container"
        //  style={{ background: 'linear-gradient(to bottom, #fff 20%, var(--primary100) 80%)' }}
         >
        <motion.div
          ref={ref}
          initial={{ y: 100, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : { opacity: 0, y: 100 }}
          transition={{ type: "spring", stiffness: 50 }}
          id='founder-letter' className='margin-large'>
        <div className="letter-heading-container">
          <img src={toastie} alt="Toastie icon" className="toastie-icon" />
          <h3 className="letter-heading">A note from the founders</h3>
        </div>
          <p>
            Toastie is designed to make tracking and understanding your health quick, easy, and fun! 🍞 It's all the tools we wish we had to help us on our health journeys, and completely redefines the way we manage our health 🚀.
          </p>
          <br/>
          <p>
            <b>Our mission</b><br/>
            Having struggled with our own chronic illnesses for years - ulcerative colitis (IBD) and polycystic ovarian syndrome (PCOS), we're building the world's leading platform for all your health needs 💖.
          </p>
          <p>
            Join us on the journey! 🌱✨
          </p>
          <img 
            src={signatureSrc} 
            alt="Founders' signatures" 
            style={{ marginTop: '2rem', maxWidth: '200px' }} 
          />
          <div className="founders-container">
            <div className="founder">
              <img src={annaSrc} alt="Profile 1" />
              <div>
                <strong>Annabel Zhou</strong><br />
                Co-founder
              </div>
            </div>
            <div className="founder">
              <img src={vivSrc} alt="Profile 2" />
              <div>
                <strong>Viv Shen</strong><br />
                Co-founder
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
};
